var scrollTop = 0;
var scrollLeft = 0;
var windowHeight =
  window.innerHeight ||
  document.documentElement.clientHeight ||
  document.body.clientHeight;
var windowWidth =
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth;
// 监听页面滚动事件
window.addEventListener("scroll", function () {
  // 获取滚动位置
  scrollTop =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;
  scrollLeft =
    window.pageXOffset ||
    document.documentElement.scrollLeft ||
    document.body.scrollLeft;
  windowHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;
  windowWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
});

function loadVideo() {
  var videoElement = document.querySelectorAll("video");
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    videoElement.forEach((video) => {
      if (video.hasAttribute("mobile-src")) {
        video.src = video.getAttribute("mobile-src");
      }
    });
  }
}

// var viewportWidth = window.innerWidth;
  window.addEventListener("load", function () {
    document.querySelectorAll(".video-hover-play").forEach((video) => {
      video.addEventListener("mouseenter", function () {
        this.querySelector("video").play(); // 鼠标进入时播放视频
      });
    });

    let io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.querySelector("video").play();
          videplay_flag = false;
          io.unobserve(entry.target);
        }
      });
    });

    document.querySelectorAll(".video-play").forEach((section) => {
      io.observe(section);
    });

    loadVideo();
  });



var mySwiper_cb = new Swiper(".cb-slide .swiper", {
  slidesPerView: 1,
});

var mySwiper_sectionknow = new Swiper(".section-know .swiper", {
  slidesPerView: 1,
  autoplay: true,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
